import DimensionListsTasksList from './DimensionListsTasksList';

export default DimensionListsTasksList;
